import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import Message from 'shared_components/message';

import SearchModulesTable from 'modules/system_setup/search_setup_table/modules';
import SearchModuleAccessTable from 'modules/system_setup/search_setup_table/moduleAccess';
import SearchMessagePromptsTable from 'modules/system_setup/search_setup_table/messagePrompts';
import SearchRolesTable from 'modules/system_setup/search_setup_table/roles';
import SearchAccessTypesTable from 'modules/system_setup/search_setup_table/accessTypes';
import SetVat from 'modules/system_setup/tab/setVatForm';
import SetTimeout from 'modules/system_setup/tab/setTimeoutForm';
import SetAnnouncements from 'modules/system_setup/tab/setAnnouncementsForm';
import SearchSetupForm from 'modules/system_setup/searchSetupForm';
import { getTimeoutAPI, getVatPercentAPI } from 'services/system_setup/fixed_values';
import { getAnnouncementAPI } from 'services/system_setup/announcement';
import OverrideRecordTab from 'modules/system_setup/tab/overrideRecordTab';
import ReportAccessManagerTab from 'modules/system_setup/tab/ReportAccessManagerTab';
import AuditTrailTab from 'modules/system_setup/tab/AuditTrailTab';
import { isRootSessionUser } from 'services/system_setup/auditTrail';

const { TabPane } = Tabs;

function TabPanes() {
    const [data, setData] = useState([]);
    const [vatPerc, setVatPerc] = useState(0);
    const [timeoutMin, setTimeoutMin] = useState(0);
    const [ann, setAnn] = useState([]);
    const isRootUser = isRootSessionUser();

    const fetchData = async()=> {
        try {
            const resVatPerc = await getVatPercentAPI();
            const resTimeoutMin = await getTimeoutAPI();
            const resAnnouncement = await getAnnouncementAPI();

            setVatPerc(resVatPerc[0].fixed_value);
            setTimeoutMin(resTimeoutMin[0].fixed_value);
            setAnn(resAnnouncement[0]);
        } catch (error) {
            console.log('fetchData Error :', error);
            Message.error(error);
        }
    }

    useEffect(()=> {
        fetchData();
    }, [vatPerc, timeoutMin]);

    const onChange = (key) => {
        console.log('xx key' ,key);
        setData([]);

        fetchData();
    };

    function search(values) {
        setData(values);
    };

    return( 
        <div>
            <Tabs defaultActiveKey='1' onChange={onChange} type='card' >
                <TabPane
                    tab='SYSTEM TIMEOUT'
                    key={1}
                >
                    <SetTimeout placeholder='SYSTEM TIMEOUT' addButton='SYSTEM TIMEOUT' onFinish={ search } timeoutMin={ timeoutMin } />
                </TabPane>
                <TabPane
                    tab='ANNOUNCEMENTS'
                    key={2}
                >
                    <SetAnnouncements placeholder='ANNOUNCEMENTS' addButton='ANNOUNCEMENTS' onFinish={ search } ann={ ann } />
                </TabPane>
                <TabPane
                    tab='MODULES'
                    key={3}
                >
                    <SearchSetupForm placeholder='MODULE NAME' addButton='MODULES' onFinish={ search } />
                    <SearchModulesTable data={data} setupValue='MODULES' />
                </TabPane>
                <TabPane
                    tab='MODULE ACCESS'
                    key={4}
                >
                    <SearchSetupForm placeholder='MODULE NAME' addButton='MODULE ACCESS' onFinish={ search } />
                    <SearchModuleAccessTable data={data} setupValue='MODULE ACCESS' />
                </TabPane>
                <TabPane
                    tab='MESSAGE PROMPTS'
                    key={5}
                >
                    <SearchSetupForm placeholder='MESSAGE CODE' addButton='MESSAGE PROMPTS' onFinish={ search } />
                    <SearchMessagePromptsTable data={data} setupValue='MESSAGE PROMPTS' />
                </TabPane>
                <TabPane
                    tab='ROLES'
                    key={6}
                >
                    <SearchSetupForm placeholder='ROLE NAME' addButton='ROLES' onFinish={ search } />
                    <SearchRolesTable data={data} setupValue='ROLES' />
                </TabPane>
                <TabPane
                    tab='VAT'
                    key={7}
                >
                    <SetVat placeholder='VAT' addButton='VAT' onFinish={ search } vatPerc={ vatPerc } />
                </TabPane>
                <TabPane
                    tab='ACCESS TYPES'
                    key={8}
                >
                    <SearchSetupForm placeholder='ACCESS TYPE NAME' addButton='ACCESS TYPES' onFinish={ search } />
                    <SearchAccessTypesTable data={data} setupValue='ACCESS TYPES' />
                </TabPane>
                <TabPane
                    tab='OVERRIDE RECORD'
                    key={9}
                >
                    <OverrideRecordTab />
                </TabPane>
                <TabPane
                    tab='REPORT ACCESS MANAGER'
                    key={10}
                >
                    <ReportAccessManagerTab />
                </TabPane>
                {
                    isRootUser
                        ? (
                            <TabPane
                                tab='AUDIT TRAIL'
                                key={11}
                            >
                                <AuditTrailTab />
                            </TabPane>
                        )
                        : <></>
                }
            </Tabs>
        </div>
    )
};

export default TabPanes;
